import React from 'react';
import { Text } from '../../../../../atoms/Text/Text';
import { dayBriefCardText, telHref } from '../../helpers';
import './DayBriefStopDetailsStyles.scss';
const baseClass = 'qmb-ui-DayBriefStopDetails';
function ContactLine({ contact }) {
    const href = contact.phone ? telHref(contact.phone) : null;
    return (React.createElement("li", { className: `${baseClass}__contact` },
        React.createElement(Text, { variant: "body" },
            contact.name,
            contact.role && React.createElement("span", { className: `${baseClass}__muted` },
                " \u00B7 ",
                contact.role)),
        contact.phone && href && (React.createElement(Text, { variant: "link", as: "a", href: href, className: `${baseClass}__phone`, "aria-label": dayBriefCardText('call', { name: contact.name, phone: contact.phone }) },
            React.createElement("i", { className: "fa-solid fa-phone", "aria-hidden": "true" }),
            contact.phone)),
        contact.phone && !href && React.createElement(Text, { variant: "body" }, contact.phone)));
}
/** Access instructions, site contacts and site notes for one stop. Empty groups are not rendered. */
export function DayBriefStopDetails({ access, contacts, siteNotes }) {
    if (access.length + contacts.length + siteNotes.length === 0)
        return null;
    return (React.createElement("div", { className: baseClass },
        access.length > 0 && (React.createElement("section", { className: `${baseClass}__group` },
            React.createElement(Text, { variant: "xx-small", as: "h5", className: `${baseClass}__label` }, dayBriefCardText('access')),
            React.createElement("ul", { className: `${baseClass}__list` }, access.map((line, index) => (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement("li", { key: `${index}-${line}`, className: `${baseClass}__access` },
                React.createElement("i", { className: `${baseClass}__access-icon fa-solid fa-key`, "aria-hidden": "true" }),
                React.createElement(Text, { variant: "body" }, line))))))),
        contacts.length > 0 && (React.createElement("section", { className: `${baseClass}__group` },
            React.createElement(Text, { variant: "xx-small", as: "h5", className: `${baseClass}__label` }, dayBriefCardText('contact')),
            React.createElement("ul", { className: `${baseClass}__list` }, contacts.map((contact, index) => (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement(ContactLine, { key: `${index}-${contact.name}`, contact: contact })))))),
        siteNotes.length > 0 && (React.createElement("section", { className: `${baseClass}__group ${baseClass}__group--wide` },
            React.createElement(Text, { variant: "xx-small", as: "h5", className: `${baseClass}__label` }, dayBriefCardText('site_notes')),
            React.createElement("ul", { className: `${baseClass}__list` }, siteNotes.map((note, index) => (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement("li", { key: `${index}-${note}`, className: `${baseClass}__note` },
                React.createElement(Text, { variant: "body" }, note)))))))));
}
